module.exports = __webpack_public_path__ + "e80e04132cc080dcc071da5f9e6eccc5.svg";